import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "reservation"
};
const _hoisted_2 = {
  class: "reservation_dom"
};
const _hoisted_3 = {
  style: {
    "color": "#fff",
    "margin-bottom": "30px"
  }
};
const _hoisted_4 = {
  class: "info"
};
const _hoisted_5 = {
  class: "info_l"
};
const _hoisted_6 = {
  class: "info_l_t"
};
const _hoisted_7 = {
  class: "dom_name"
};
const _hoisted_8 = {
  class: "dom_name"
};
const _hoisted_9 = {
  class: "info_l_b"
};
const _hoisted_10 = {
  class: "info_l_b_tab"
};
const _hoisted_11 = {
  class: "info_r"
};
const _hoisted_12 = {
  class: "info_r_r"
};
const _hoisted_13 = {
  class: "info_r_r_text"
};
const _hoisted_14 = {
  style: {
    "position": "absolute",
    "top": "-95px",
    "left": "-48px"
  }
};
const _hoisted_15 = {
  style: {
    "margin-bottom": "5px",
    "font-size": "15px",
    "font-family": "siyuan_Regular",
    "font-weight": "400",
    "color": "#FFFFFF"
  }
};
const _hoisted_16 = {
  style: {
    "font-size": "15px",
    "font-family": "siyuan_Regular",
    "font-weight": "400",
    "color": "#FFFFFF"
  }
};
const _hoisted_17 = {
  style: {
    "margin-bottom": "5px",
    "font-size": "15px",
    "font-family": "siyuan_Regular",
    "font-weight": "400",
    "color": "#FFFFFF"
  }
};
const _hoisted_18 = {
  style: {
    "font-size": "15px",
    "font-family": "siyuan_Regular",
    "font-weight": "400",
    "color": "#FFFFFF"
  }
};
const _hoisted_19 = {
  style: {
    "margin-bottom": "5px",
    "font-size": "15px",
    "font-family": "siyuan_Regular",
    "font-weight": "400",
    "color": "#FFFFFF"
  }
};
const _hoisted_20 = {
  style: {
    "font-size": "15px",
    "font-family": "siyuan_Regular",
    "font-weight": "400",
    "color": "#FFFFFF"
  }
};
const _hoisted_21 = {
  class: "info_r_l"
};
const _hoisted_22 = {
  style: {
    "width": "80%"
  }
};
const _hoisted_23 = {
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "margin-top": "20px",
    "position": "relative"
  }
};
const _hoisted_24 = {
  key: 0,
  class: "gongzhonghaoCode code-box"
};
const _hoisted_25 = {
  key: 1,
  class: "weiboCode code-box"
};
const _hoisted_26 = {
  key: 2,
  class: "xhsCode code-box"
};
const _hoisted_27 = {
  key: 3,
  class: "douyinCode code-box"
};
const _hoisted_28 = {
  class: "aq"
};
const _hoisted_29 = {
  href: "https://beian.miit.gov.cn/#/Integrated/index"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image");
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_popup = _resolveComponent("popup");
  const _component_footerPCM = _resolveComponent("footerPCM");
  return $setup.Client == 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    style: _normalizeStyle(['zoom:' + ($setup.Client ? '20%' : '') + ';', {
      "min-width": "1560px",
      "width": "100%"
    }])
  }, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_image, {
    src: "https://www.mimodental.com/assets/imgData/img/footer/Group256@2x.png"
  }), _createElementVNode("div", _hoisted_2, [_createElementVNode("h1", _hoisted_3, _toDisplayString($setup.route.name == 'welfare_details' ? '即刻报名，纠正口腔不良习惯' : '立即申请预约，了解更多详细信息'), 1), _createElementVNode("div", {
    class: "reservation_btn",
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.show && $setup.show(...args))
  }, _toDisplayString($setup.route.name == 'welfare_details' ? '公益报名' : '点击预约'), 1)])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", {
    class: "info_l_t_dom",
    onClick: _cache[1] || (_cache[1] = $event => $setup.go('seek'))
  }, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_van_image, {
    src: "https://www.mimodental.com/assets/imgData/img/footer/Frame.png"
  }), _cache[18] || (_cache[18] = _createElementVNode("span", null, "查找更多口腔问题", -1))]), _createVNode(_component_van_icon, {
    name: "arrow",
    color: "#fff",
    size: "10px"
  })]), _createElementVNode("div", {
    class: "info_l_t_dom",
    onClick: _cache[2] || (_cache[2] = $event => $setup.go('news'))
  }, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_van_image, {
    src: "https://www.mimodental.com/assets/imgData/img/footer/news.png"
  }), _cache[19] || (_cache[19] = _createElementVNode("span", null, "查看更多新闻资讯", -1))]), _createVNode(_component_van_icon, {
    name: "arrow",
    color: "#fff",
    size: "10px"
  })])]), _createElementVNode("div", _hoisted_9, [_cache[27] || (_cache[27] = _createElementVNode("h3", null, "快速链接", -1)), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", null, [!$setup.userData ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    onClick: _cache[3] || (_cache[3] = (...args) => $setup.login && $setup.login(...args))
  }, [_cache[20] || (_cache[20] = _createTextVNode("登录/注册 ", -1)), _createVNode(_component_van_icon, {
    name: "arrow",
    color: "#fff",
    size: "10px"
  })])) : _createCommentVNode("", true), _createElementVNode("span", {
    onClick: _cache[4] || (_cache[4] = $event => $setup.go('about'))
  }, [_cache[21] || (_cache[21] = _createTextVNode("关于米檬", -1)), _createVNode(_component_van_icon, {
    name: "arrow",
    color: "#fff",
    size: "10px"
  })]), _createElementVNode("span", {
    onClick: _cache[5] || (_cache[5] = $event => $setup.go('Zone'))
  }, [_cache[22] || (_cache[22] = _createTextVNode("诊疗专区", -1)), _createVNode(_component_van_icon, {
    name: "arrow",
    color: "#fff",
    size: "10px"
  })]), _createElementVNode("span", {
    onClick: _cache[6] || (_cache[6] = $event => $setup.go('seek'))
  }, [_cache[23] || (_cache[23] = _createTextVNode("查找疾病", -1)), _createVNode(_component_van_icon, {
    name: "arrow",
    color: "#fff",
    size: "10px"
  })])]), _createElementVNode("div", null, [_createElementVNode("span", {
    onClick: _cache[7] || (_cache[7] = $event => $setup.go('news'))
  }, [_cache[24] || (_cache[24] = _createTextVNode("新闻资讯", -1)), _createVNode(_component_van_icon, {
    name: "arrow",
    color: "#fff",
    size: "10px"
  })]), _createElementVNode("span", {
    onClick: _cache[8] || (_cache[8] = $event => $setup.go('science'))
  }, [_cache[25] || (_cache[25] = _createTextVNode("口腔科普", -1)), _createVNode(_component_van_icon, {
    name: "arrow",
    color: "#fff",
    size: "10px"
  })]), _createElementVNode("span", {
    onClick: _cache[9] || (_cache[9] = $event => $setup.go('welfare'))
  }, [_cache[26] || (_cache[26] = _createTextVNode("米檬公益", -1)), _createVNode(_component_van_icon, {
    name: "arrow",
    color: "#fff",
    size: "10px"
  })])])])])]), _cache[43] || (_cache[43] = _createElementVNode("div", {
    class: "info_c"
  }, null, -1)), _createVNode(_component_popup, {
    show: $setup.loginShow,
    showState: $setup.showState,
    onModifyShowState: $setup.modifyShowState,
    onGetUserData: $setup.getUserData
  }, null, 8, ["show", "showState", "onModifyShowState", "onGetUserData"]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_van_image, {
    src: "https://www.mimodental.com/assets/imgData/img/footer/Group 254@2x.png"
  }), _createElementVNode("div", _hoisted_13, [_createElementVNode("h3", _hoisted_14, [_createVNode(_component_van_image, {
    style: {
      "width": "232px",
      "height": "60px"
    },
    src: "https://www.mimodental.com/assets/imgData/img/footer/contactUs.png"
  })]), _createElementVNode("div", null, [_cache[30] || (_cache[30] = _createElementVNode("h2", {
    style: {
      "font-size": "18px",
      "font-family": "siyuan_Bold",
      "font-weight": "bold",
      "color": "#FFFFFF"
    }
  }, " 米檬口腔（珠江新城店）", -1)), _createElementVNode("span", _hoisted_15, [_createVNode(_component_van_icon, {
    name: "location",
    color: "#fff",
    size: "16px",
    style: {
      "margin-right": "14px"
    }
  }), _cache[28] || (_cache[28] = _createTextVNode("广州市天河区黄埔大道西高志大厦3楼", -1))]), _createElementVNode("span", _hoisted_16, [_createVNode(_component_van_icon, {
    name: "phone",
    color: "#fff",
    size: "16px",
    style: {
      "margin-right": "14px"
    }
  }), _cache[29] || (_cache[29] = _createTextVNode("13326412720/020-83625907", -1))])]), _createElementVNode("div", null, [_cache[33] || (_cache[33] = _createElementVNode("h2", {
    style: {
      "font-size": "18px",
      "font-family": "siyuan_Bold",
      "font-weight": "bold",
      "color": "#FFFFFF"
    }
  }, " 米檬口腔（黄埔旗舰店）", -1)), _createElementVNode("span", _hoisted_17, [_createVNode(_component_van_icon, {
    name: "location",
    color: "#fff",
    size: "16px",
    style: {
      "margin-right": "14px"
    }
  }), _cache[31] || (_cache[31] = _createTextVNode("广州市黄埔区开创大道雪松中心103铺", -1))]), _createElementVNode("span", _hoisted_18, [_createVNode(_component_van_icon, {
    name: "phone",
    color: "#fff",
    size: "16px",
    style: {
      "margin-right": "14px"
    }
  }), _cache[32] || (_cache[32] = _createTextVNode("020-32030994/18024089930", -1))])]), _createElementVNode("div", null, [_cache[36] || (_cache[36] = _createElementVNode("h2", {
    style: {
      "font-size": "18px",
      "font-family": "siyuan_Bold",
      "font-weight": "bold",
      "color": "#FFFFFF"
    }
  }, " 米檬口腔（番禺青春店）", -1)), _createElementVNode("span", _hoisted_19, [_createVNode(_component_van_icon, {
    name: "location",
    color: "#fff",
    size: "16px",
    style: {
      "margin-right": "14px"
    }
  }), _cache[34] || (_cache[34] = _createTextVNode("广州市番禺区钟村街文都二街6号(保利大都汇北侧)", -1))]), _createElementVNode("span", _hoisted_20, [_createVNode(_component_van_icon, {
    name: "phone",
    color: "#fff",
    size: "16px",
    style: {
      "margin-right": "14px"
    }
  }), _cache[35] || (_cache[35] = _createTextVNode("020-36880989/19065227202", -1))])])])]), _createElementVNode("div", _hoisted_21, [_cache[42] || (_cache[42] = _createElementVNode("div", {
    style: {
      "margin": "30px 0",
      "display": "flex",
      "flex-direction": "column",
      "align-items": "center"
    }
  }, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/code2.png",
    alt: "",
    style: {
      "margin-bottom": "20px",
      "width": "150px",
      "height": "150px"
    }
  }), _createElementVNode("span", null, "扫一扫，找客服了解更多")], -1)), _createElementVNode("div", _hoisted_22, [_cache[41] || (_cache[41] = _createElementVNode("div", {
    style: {
      "background-color": "#fff",
      "color": "#13A4BF",
      "width": "200px",
      "text-align": "center",
      "padding": "5px 0",
      "border-radius": "100px"
    }
  }, " 还可以在这里找到我们", -1)), _createElementVNode("div", _hoisted_23, [_createElementVNode("img", {
    onMouseenter: _cache[10] || (_cache[10] = $event => $setup.showCode(0)),
    onMouseleave: _cache[11] || (_cache[11] = (...args) => $setup.hideCode && $setup.hideCode(...args)),
    src: "https://www.mimodental.com/assets/imgData/img/footer/Group35.png",
    alt: ""
  }, null, 32), _createElementVNode("img", {
    onMouseenter: _cache[12] || (_cache[12] = $event => $setup.showCode(1)),
    onMouseleave: _cache[13] || (_cache[13] = (...args) => $setup.hideCode && $setup.hideCode(...args)),
    src: "https://www.mimodental.com/assets/imgData/img/footer/Group36.png",
    alt: ""
  }, null, 32), _createElementVNode("img", {
    onMouseenter: _cache[14] || (_cache[14] = $event => $setup.showCode(2)),
    onMouseleave: _cache[15] || (_cache[15] = (...args) => $setup.hideCode && $setup.hideCode(...args)),
    src: "https://www.mimodental.com/assets/imgData/img/footer/Group37.png",
    alt: ""
  }, null, 32), _createElementVNode("img", {
    onMouseenter: _cache[16] || (_cache[16] = $event => $setup.showCode(3)),
    onMouseleave: _cache[17] || (_cache[17] = (...args) => $setup.hideCode && $setup.hideCode(...args)),
    src: "https://www.mimodental.com/assets/imgData/img/footer/Group38.png",
    alt: ""
  }, null, 32), $setup.codeShowState && $setup.codeShowIndex == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_24, _cache[37] || (_cache[37] = [_createElementVNode("div", {
    style: {
      "position": "relative"
    }
  }, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/gongzhonghao.png",
    alt: ""
  }), _createElementVNode("div", {
    class: "code-arrow"
  })], -1)]))) : $setup.codeShowState && $setup.codeShowIndex == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_25, _cache[38] || (_cache[38] = [_createElementVNode("div", {
    style: {
      "position": "relative"
    }
  }, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/weiboCode.png",
    alt: ""
  }), _createElementVNode("div", {
    class: "code-arrow"
  })], -1)]))) : _createCommentVNode("", true), $setup.codeShowState && $setup.codeShowIndex == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_26, _cache[39] || (_cache[39] = [_createElementVNode("div", {
    style: {
      "position": "relative"
    }
  }, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/xhs.png",
    alt: ""
  }), _createElementVNode("div", {
    class: "code-arrow"
  })], -1)]))) : _createCommentVNode("", true), $setup.codeShowState && $setup.codeShowIndex == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_27, _cache[40] || (_cache[40] = [_createElementVNode("div", {
    style: {
      "position": "relative"
    }
  }, [_createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/imgs/douyin.png",
    alt: ""
  }), _createElementVNode("div", {
    class: "code-arrow"
  })], -1)]))) : _createCommentVNode("", true)])])])])]), _createElementVNode("div", _hoisted_28, [_createTextVNode(_toDisplayString($setup.textObj.name) + " " + _toDisplayString($setup.textObj.num) + " ", 1), _createElementVNode("a", _hoisted_29, _toDisplayString($setup.textObj.code), 1)])], 4)) : (_openBlock(), _createBlock(_component_footerPCM, {
    key: 1
  }));
}